/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Distillation_Technical_SpecInputs */



/**
* | output |
* | --- |
* | "Technical Spec" |
*
* @param {Distillation_Technical_SpecInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const distillation_technical_spec = /** @type {((inputs?: Distillation_Technical_SpecInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Distillation_Technical_SpecInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Technische Spezifikation")
	return /** @type {LocalizedString} */ ("Technical Spec")
});